<template>
	<div class="submitWrapper minHeight">
		<IndexHeaderOthers ref="indexHeader"></IndexHeaderOthers>
		<div class="main">
			<div class="conner">
				<div class="h1">{{subscribeTitle}}</div>
				<div class="desc">
					{{subscribeDesc}}
				</div>
				<div class="tabConner">
					<span>Object class</span>
					<i class="el-icon-arrow-down" @click="closeGroupList" v-show="showGroupList"></i>
					<i class="el-icon-arrow-right" @click="closeGroupList" v-show="!showGroupList"></i>
				</div>
				<div class="groupList" v-show="showGroupList">
					<el-checkbox-group v-model="checkList">
						<el-checkbox v-for="(item, index) in Objectclass" :key="index" :label="item">{{ item.name }}
						</el-checkbox>
					</el-checkbox-group>
				</div>
				<div class="tabConner">
					<span>Telescope</span>
					<i class="el-icon-arrow-down" @click="closeGroupAllList" v-show="showGroupAllList"></i>
					<i class="el-icon-arrow-right" @click="closeGroupAllList" v-show="!showGroupAllList"></i>
				</div>
				<div class="groupAllList" v-show="showGroupAllList">
					<div class="listAll" v-for="(item, index) in Telescope" :key="index">
						<el-checkbox v-model="item.checkAll" @change="handleCheckAllChange(item)" class="checkAll">
							{{ item.name }}
						</el-checkbox>
						<el-checkbox-group v-model="item.checked" @change="handleCheckedChange(item)" style="flex: 1">
							<el-checkbox v-for="(item2, index2) in item.children" :label="item2.id" :key="index2"
								:value="item.id">{{ item2.name }}
							</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="tabConner">
					<span>Event name</span>
					<i class="el-icon-arrow-down" @click="closeShowSearchALL" v-show="showSearchALL"></i>
					<i class="el-icon-arrow-right" @click="closeShowSearchALL" v-show="!showSearchALL"></i>
				</div>
				<div class="searchALL" v-show="showSearchALL">
					<div class="search">
						<div class="label">Event name</div>
						<div class="selectDiv">
							<i class="el-icon-search" @click="goSearch"></i>
							<!-- <el-select v-model="Object_name" filterable reserve-keyword placeholder="Variables"
								:loading="loading" @change="changeValue">
								<el-option v-for="item in Objectname" :key="item.name" :label="item.name"
									:value="item.id">
									<template :scope="item">
										<div class="orderSubmit">
											<span>{{ item.name }}</span>
											<span>Subscribe</span>
										</div>
									</template>
								</el-option>
							</el-select> -->
							
							<el-select
							                       style="width:68%"
							                       v-model="Object_name"
							                       clearable
							                       filterable
							                       v-selectLoadMore="selectLoadMore"
							                       :loading="loading"
							                       remote
							                       :remote-method="remoteMethod"
												   @change="changeValue"
							                       placeholder="Variables">
							              <el-option v-for="item in Objectname" :key="item.name" :label="item.name"
							              	:value="item.id">
							              	<template :scope="item">
							              		<div class="orderSubmit">
							              			<span>{{ item.name }}</span>
							              			<span>Subscribe</span>
							              		</div>
							              	</template>
							              </el-option>
							            </el-select>
						</div>
					</div>
					<div class="subscribed">
						<div class="label" style="width: 130px">subscribed</div>
						<!-- 多选  -->
						<el-checkbox-group style="flex: 1" v-model="subscribedGroupArray" @change="changeCheckBox">
							<el-checkbox v-for="(item, index) in subscribedGroup" :key="index" :label="item.id">
								{{ item.name }}
							</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
			</div>
			<div class="flexCenter" style="margin-top: 30px; margin-bottom: 50px">
				<div class="cancel" @click="cancelForm">Cancel</div>
				<div class="submit" @click="onSubmit">Submit</div>
			</div>
		</div>
	</div>
</template>
<script>
	import IndexHeaderOthers from "../components/header/indexHeaderOthers.vue";
	export default {
		name: "subPage",
		components: {
			IndexHeaderOthers,
		},
		data() {
			return {
				pageSize:3,
				currentpage:1,
				abc:[],
				Objectclass: "",
				Telescope: "",
        TelescopeChildrenArr:[],
				subscribedGroupArray: [],
				Objectname: [],
				Object_name: "",
				showGroupList: true,
				showSearchALL: true,
				showGroupAllList: true,
				options: [],
				AllList: [],
				checkList: [],
				ListGroup: [],
				subscribedList: [],
				subscribedGroup: [],
				arr: [],
				loading: false,
				subscribeDesc: '',
				subscribeTitle: '',
				search:{
					pageNum:1,
					pageSize:10,
				}
			};
		},
		mounted() {
			this.getData();
			this.subscribeDesc = JSON.parse(localStorage.getItem('columnDetail')).subscribeDesc.description
			this.subscribeTitle = JSON.parse(localStorage.getItem('columnDetail')).subscribeTitle.description
			// window.addEventListener("scroll", this.$refs.indexHeader.scrollToTop, true);
		},
		methods: {
			handleCurrentChange(val){
				console.log(val)
			},
			closeGroupList() {
				this.showGroupList = !this.showGroupList;
			},
			closeGroupAllList() {
				this.showGroupAllList = !this.showGroupAllList;
			},
			closeShowSearchALL() {
				this.showSearchALL = !this.showSearchALL;
			},
			handleSelect(item) {
				console.log(item);
			},
			goSearch() {
				console.log(this.object_name);
			},
			selectLoadMore() {
			  this.search.pageNum = this.search.pageNum + 1;
			  if (this.search.pageNum > this.totalPage) return;
			  this.readAllUsers(); // 请求接口
			},
			remoteMethod(query) {
			  this.loading = true;
			  this.search.query = query;
			  this.search.pageNum = 1;
			  this.Objectname = [];
			  setTimeout(() => {
				this.loading = false;
				this.readAllUsers(); // 请求接口
			  }, 200)
			},
			readAllUsers(){
				this.$fetchGet("cms-middle/astronTag/list?pageNo=" + this.search.pageNum + '&pageNum=' + this.search.pageSize + '&type=event_name' + '&name=' + this.search.query)
				.then(res => {
					console.log(res)
					if(res.page.records.length == 0){
						this.$message.success("no data");
						this.Objectname = []
					}else{
						for(var i = 0; i < res.page.records.length; i++){
							this.Objectname.push(res.page.records[i])
						}
						for (var i = 0; i < this.Objectname.length; i++) {
							if (this.Objectname[i].checked) {
								if (this.Objectname[i].checked == 'checked') {
									this.subscribedGroup.push(this.Objectname[i])
									this.subscribedGroupArray.push(this.Objectname[i].id)
								}
							}
						}
					}
				})
			},
			changeCheckBox(e) {
				this.subscribedGroup.forEach((item, index, array) => {
					if (e.indexOf(item.id) == -1) {
						if (this.Object_name == item.id) {
							this.Object_name = "";
						}

						this.subscribedGroup.splice(index, 1);
						if (this.subscribedGroup.length != 0) {
							// console.log(this.subscribedGroup[0])
							this.Object_name = this.subscribedGroup[0].id;
						}
					}
				});
			},
			cancelForm() {
				window.location.reload();
			},
			changeValue(e) {
				let item = {};
				for (let i in this.Objectname) {
					if (this.Objectname[i].id == e) {
						item = this.Objectname[i];
					}
				}
				if (this.subscribedGroupArray.indexOf(e) != -1) {
					return;
				}
				this.subscribedGroup.push(item);
				this.subscribedGroupArray.push(item.id);
				//   this.Object_name = e.id;
				//   console.log(this.subscribedGroup);
			},
			// subscribeTagids
			submitCked(item) {
				let a = item.name;
				if (this.arr.includes(a)) {
					this.arr = this.arr.filter(function(ele) {
						console.log(ele);
						return ele != a;
					});
					item.status = 0;
				} else {
					this.arr.push(a);
					item.status = 1;
				}
			},
			querySearch(queryString, cb) {
				var restaurants = this.options;
				var results = queryString ?
					restaurants.filter(this.createFilter(queryString)) :
					restaurants;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			createFilter(queryString) {
				return (restaurant) => {
					return (
						restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !=
						-1
					);
				};
			},
			getData(name) {
				this.$fetchGet("/cms-middle/member/subscribe")
					.then((res) => {
						(this.Objectclass = res.data.object_class),
						(this.Telescope = res.data.telescope);
            let  teleArr = []
            res.data.telescope.forEach((item)=>{
              if(item.children){
                item.children.forEach((jitem)=>{
                  teleArr.push(jitem)
                })
              }
            })

            this.TelescopeChildrenArr = teleArr;

						// (this.Objectname = res.data.event_name)
						for (var i = 0; i < this.Objectclass.length; i++) {
							if (this.Objectclass[i].checked) {
								if (this.Objectclass[i].checked == 'checked') {
									this.checkList.push(this.Objectclass[i])
								}
							}
						}
						for (var i = 0; i < this.Telescope.length; i++) {
							this.$set(this.Telescope[i], "checked", []);
							this.$set(this.Telescope[i], "checkAll", false);
						}
						for (var i = 0; i < this.Telescope.length; i++) {
							if (this.Telescope[i].children.findIndex(target => target.checked == '') == -1) {
								console.log(123)
								this.Telescope[i].checkAll = true;
							} else {
								console.log(12311111)
								this.Telescope[i].checkAll = false;
							}
							for (var j = 0; j < this.Telescope[i].children.length; j++) {
								if (this.Telescope[i].children[j].checked) {
									if (this.Telescope[i].children[j].checked == 'checked') {
										this.Telescope[i].checked.push(this.Telescope[i].children[j].id)
									}
								}
							}
						}
						for (var i = 0; i < res.data.event_name.length; i++) {
							if (res.data.event_name[i].checked) {
								if (res.data.event_name[i].checked == 'checked') {
									this.subscribedGroup.push(res.data.event_name[i])
									this.subscribedGroupArray.push(res.data.event_name[i].id)
								}
							}
						}
					})
					.catch((err) => {});
			},
			onSubmit() {
				console.log(this.Telescope);
	
        // id
				var a = [];
				for (var i = 0; i < this.checkList.length; i++) {
					a.push(this.checkList[i].id);
				}
				var b = [];
				for (var i = 0; i < this.subscribedGroup.length; i++) {
					b.push(this.subscribedGroup[i].id);
				}
				var c = [];
				for (var i = 0; i < this.Telescope.length; i++) {
					for (var j = 0; j < this.Telescope[i].checked.length; j++) {
						c.push(this.Telescope[i].checked[j]);
					}
				}
				console.log(c);
				a = a.concat(b);
				c = a.concat(c);
				console.log(a);
				var allObject = "";
				allObject = c.join(",");

        // name
          var aName = [];
          for (var i = 0; i < this.checkList.length; i++) {
            aName.push(this.checkList[i].name);
          }
          var bName = [];
          for (var i = 0; i < this.subscribedGroup.length; i++) {
            bName.push(this.subscribedGroup[i].name);
          }
          var cName = [];
          for (var i = 0; i < this.Telescope.length; i++) {
            for (var j = 0; j < this.Telescope[i].checked.length; j++) {
              cName.push(this.Telescope[i].checked[j]);
            }
          }

         

          // 处理  Telescope name
          var dName = [];
          if(cName){
            cName.forEach((code)=>{
              this.Telescope.forEach((item)=>{
                if(item.children) {
                  item.children.forEach((jItem)=>{
                    if(code ==jItem.id) {
                      dName.push(jItem.name)
                    }
                  })
                }
                
              });
            })
          }

          aName = aName.concat(bName);
          dName = aName.concat(dName);

          console.log(aName);
          var allObjectName = "";
          allObjectName = dName.join(",");

          console.log('namenamenamenamenamenamenamename')
          console.log(cName)



				this.$fetchPost(
						"/cms-middle/member/subscribe", {
							subscribeTagids: allObject,
              subscribeTagNames:allObjectName
						}, {
							"Content-Type": "application/json",
						}
					)
					.then((res) => {
						console.log(res);
						this.$message.success("Submitted successfully");
					})
					.catch((err) => {});
			},
			handleCheckAllChange(val) {
				console.log(val);
				// 单选
				for (var i = 0; i < val.children.length; i++) {
					if (val.checkAll == true) {
						val.checked.push(val.children[i].id);
					} else {
						val.checked = [];
					}
				}
			},
			handleCheckedChange(val) {
				console.log(val);
				let checkedCount = val.checked.length;
				// 是否全选
				val.checkAll = checkedCount === val.children.length;
			},
		},
	};
</script>
<style>
	.el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner{
		text-align:center!important
	}
	.el-select .el-input--suffix .el-input__inner{
		text-align:center!important
	}
	.el-input .el-input__inner{
		text-align:center!important
	}
</style>
<style scoped lang="less">
	.orderSubmit {
		display: flex;
		align-items: center;
		justify-content: space-between;

		span {
			&:nth-child(2) {
				// width: 56px;
				// height: 24px;
				margin-left: 10px;
				line-height: 24px;
				// background: #168ec7;
				border-radius: 17px;
				font-size: 14px;
				font-family: Alibaba Sans;
				font-weight: 500;
				color: #168ec7;
				padding: 0 !important;
				text-align: center;
				cursor: pointer;
			}
		}
	}

	.submitBoxList {
		display: flex;
		flex-wrap: wrap;
		flex: 1;

		.submitBox {
			margin-right: 20px;
			display: flex;
			align-items: center;
			// height: 40px;
			margin-bottom: 16px;

			.submitName {
				color: #606266;
				font-weight: 500;
				font-size: 14px;
				display: block;
				margin-right: 4px;
			}

			.submitCheck {
				padding: 2px 8px;
				background-color: #168ec7;
				color: #ffffff;
				font-size: 14px;
				border-radius: 30px;
				cursor: pointer;
			}

			.submitNoCheck {
				padding: 2px 8px;
				background-color: #e6ebf3;
				color: #666666;
				font-size: 14px;
				border-radius: 30px;
				cursor: pointer;
			}
		}
	}

	.selectDiv {
		position: relative;
	}

	.search .el-icon-search {
		width: 25px;
		font-size: 14px;
		color: #008dc9;
		line-height: 36px;
		position: absolute;
		z-index: 99;
		right: 0;
	}

	/deep/ .el-select .el-input__suffix {
		opacity: 0;
	}

	.main {
		position: relative;
		margin-top: -70px;
		z-index: 99;
		width: 100%;
		height: auto;
		background: #fff;
		border-radius: 0 120px 0 0;
	}

	.groupList {
		margin: 15px;
		font-size: 14px;
		font-family: Alibaba Sans;
		font-weight: 400;
		color: #666666;
		line-height: 36px;
	}

	.conner {
		width: 1050px;
		margin: 0 auto;
		text-align: left;
	}

	.h1 {
		height: 23px;
		font-size: 20px;
		font-family: Alibaba Sans;
		font-weight: bold;
		color: #168ec7;
		line-height: 23px;
		padding-top: 37px;
		padding-bottom: 18px;
	}

	.desc {
		font-size: 11px;
		font-family: Alibaba Sans;
		color: #222222;
		font-weight: 500;
		line-height: 18px;
	}

	.tabConner {
		height: 40px;
		border-top: 2px solid #008dc9;
		background: #f0f3f8;
		margin-top: 32px;
		font-size: 15px;
		font-family: Alibaba Sans;
		font-weight: bold;
		color: #168ec7;
		line-height: 42px;
		text-indent: 1em;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-right: 12px;
	}

	.listAll {
		display: flex;
		padding: 5px 0;
		/* align-items: center; */
		font-size: 14px !important;
	}

	.groupAllList,
	.searchALL {
		margin: 15px;
	}
	.groupAllList{
		min-height: 400px;
	}
	.groupList{
		min-height: 100px;
	}
	.checkAll {
		width: 130px;
		font-weight: bold;
		color: #333333;
	}

	.search {
		display: flex;
		align-items: center;
	}

	.subscribed {
		display: flex;
		margin-top: 30px;
		font-size: 14px !important;
	}

	.search .label,
	.subscribed .label {
		width: 130px;
		font-size: 14px;
		font-family: Alibaba Sans;
		font-weight: bold;
		color: #333333;
	}
</style>
<style>
	.checkAll .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #333 !important;
	}

	.listAll .el-checkbox__label,
	.groupList .el-checkbox__label,
	.subscribed .el-checkbox__label {
		padding-left: 5px !important;
	}

	.listAll .el-checkbox,
	.subscribed .el-checkbox {
		height: 40px;
		margin-right: 16px !important;
	}

	.search input,
	.search .el-input {
		width: 315px;
		height: 36px;
	}

	.search .el-input__icon {
		color: #008dc9;
		line-height: 36px;
	}

	.searchALL input,
	.searchALL .el-input {
		width: 193px !important;
		border-radius: 35px;
	}
</style>
